import Swiper from 'swiper';

class ProductFilterPresets {
  private elScope: HTMLElement;

  private el: {
    buttonFilters: NodeListOf<HTMLElement>;
    items: NodeListOf<HTMLElement>;
    nav: HTMLElement;
  }

  constructor(elScope: HTMLElement) {
    this.elScope = elScope;
    this.el = {
      buttonFilters: this.elScope.querySelectorAll('.js-o-pfp__filter[data-category]'),
      items: this.elScope.querySelectorAll('.js-o-pfp__item[data-category]'),
      nav: this.elScope.querySelector('.js-o-pfp__nav') as HTMLElement,
    }

  }

  init() {
    const { el } = this;

    el.buttonFilters.forEach((elButton) => {
      elButton.addEventListener('click', () => this.onFilter(elButton.dataset.category || '', elButton));
    });

    new Swiper(el.nav, {
      speed: 800,
      slidesPerView: 4,
      spaceBetween: 0,
      loop: false,
      slideClass: 'm-product-filters-preset',
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
      },
    });
  }

  private onFilter(term: string, elFilter: HTMLElement) {
    const { el } = this;
    const termSelected = term.toLowerCase();
    const forceShow = termSelected === '_all';


    // Toggle items
    el.items.forEach((el) => {
      const termCurrent = el.dataset.category?.toLowerCase();
      const isHidden = !forceShow && termCurrent !== termSelected;
      el.classList.toggle('is-hidden', isHidden);
    });

    // Toggle active items
    el.buttonFilters.forEach((el) => {
      el.classList.remove('is-active');
    });
    elFilter.classList.add('is-active');
  }
}

export default ProductFilterPresets;
